/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name Circle
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDIwLjVhOC41IDguNSAwIDEwMC0xNyA4LjUgOC41IDAgMDAwIDE3bTAgMS41YzUuNTIzIDAgMTAtNC40NzcgMTAtMTBTMTcuNTIzIDIgMTIgMiAyIDYuNDc3IDIgMTJzNC40NzcgMTAgMTAgMTAiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==) - https://fondue-components.frontify.com/?path=/story/icons_icons--default&args=iconName:circle
 * @see https://fondue-components.frontify.com/?path=/story/icons_icons--default - Documentation
 */
export const IconCircle = createFondueIcon('Circle', [["path",{"fill":"currentColor","fill-rule":"evenodd","d":"M12 20.5a8.5 8.5 0 100-17 8.5 8.5 0 000 17m0 1.5c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10","clip-rule":"evenodd"}]]);
